/**
 * Shim for @clariness/labeled-radio-button: re-exports with optional pointer/crossOrigin props
 * so React 19 types don't require them (theme-ui Pick<> types treat them as required).
 */
import React from 'react';
import {
  LabeledRadioButton as OrigLabeledRadioButton,
  type LabeledRadioProps,
} from '~clariness-labeled-radio-button';

type OptionalProps = {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
  crossOrigin?: string;
};

export type { LabeledRadioProps };
export const LabeledRadioButton =
  OrigLabeledRadioButton as React.ForwardRefExoticComponent<
    Omit<
      React.ComponentProps<typeof OrigLabeledRadioButton>,
      keyof OptionalProps
    > &
      OptionalProps &
      React.RefAttributes<HTMLInputElement>
  >;
